import { Directive, HostListener, Input } from '@angular/core';

import { ModalService } from 'src/app/core/services/modal.service';
import { ModalDirective } from './modal.directive';

@Directive({
  selector: '[appFullText]'
})
export class FullTextDirective {
  @Input() title: string;
  @Input() text: string;
  @Input() modal: ModalDirective;

  @HostListener('click') showFullText() {
    this.modalService.showFullText(this.title, this.text, this.modal);
  }

  constructor(private modalService: ModalService) {}
}
